import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>

                                            <div className="uiheading"><p>Once you have completed the exercise
                                                above, having identified team roles and assigned
                                                responsibility for tasks:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Consider whether the absence of certain roles will be a
                                                    problem; for example, if there’s no
                                                    ‘implementer’, how will ideas be made to work? In this
                                                    situation think who else in the team
                                                    may have the skills and be willing to accommodate another
                                                    role. If there’s no one, do you
                                                    need to source an extra team member with appropriate skills?
                                                </li>
                                                <li>Think about whether there are too many people in the team
                                                    with the same role;
                                                    for example, if there are four ‘plants’, will there be
                                                    conflict? Perhaps tasks should be
                                                    assigned to individuals rather than ‘roles’ to avoid
                                                    problems.
                                                </li>
                                                <li>Think about any gaps in the team’s skills. For example, are
                                                    there any necessary roles
                                                    not represented?
                                                </li>
                                            </ul>

                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/puzzle_win.png')}
                                                    alt=""/>

                                            </div>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page10')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}